import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { INSTITUTE_STATUS } from '@/features/institutes/constants/institute.constants';
import { InstituteListPage } from '@/features/institutes/pages/InstituteListPage';

export const instituteListSearchSchema = z.object({
  instituteTypeId: z.coerce.number().int().positive().optional(),
  examBoardId: z.coerce.number().int().positive().optional(),
  divisionId: z.coerce.number().int().positive().optional(),
  districtId: z.coerce.number().int().positive().optional(),
  thanaId: z.coerce.number().int().positive().optional(),
  status: z.enum(INSTITUTE_STATUS).optional(),
  eiinNumber: z.string().optional(),
  name: z.string().optional(),
  _pendingId: z.coerce.number().int().positive().optional(),
});

export type InstituteListSearch = z.infer<typeof instituteListSearchSchema>;

export const Route = createFileRoute('/_auth/settings/institutes/')({
  validateSearch: instituteListSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Institutes">
      <Suspense fallback={<PageLoader />}>
        <InstituteListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
